import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DiySolarParts = () => {
  return (
    <div>
      <Navbar />
      <div className="container mx-auto  py-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* DIY Solar Parts Card */}
        <div className="bg-white shadow-md rounded-md p-6 lg:col-span-2">
          <h1 className="text-2xl font-bold mb-4">DIY Solar Parts</h1>
          <p className="mb-6">
            This list consists of some of the DIY solar parts that I recommend.
            Some of these links earn me a commission at no extra cost to you.
          </p>

          {/* Batteries Section */}
          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">Batteries</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                12V 100Ah LiFePO4 low temp protection:{" "}
                <Link
                  to="https://www.amazon.com/Litime-LiFePO4-Protection-Rechargeable-Trolling/dp/B0C8T1FD7M?crid=1YP8HKME172O9&dib=eyJ2IjoiMSJ9.IIw1pwUp1LZxEA9xQL03QG5Hsv-5RnS8JVbEGKdMWMPc6btxEPR0a5MPleKa7H73KJd_9Zntlagssp8GANNbfNKe4bHvny-d7Bvx-QUVxgLtn4dKSS_sIhur2IT3Ll3qHuwIzgWzQZtOEtZsh428fM3u9E1tevxBJ8636crpaK5RdmhZp8A0cChqvrqHl6IA0gyFSnyKbvZrl6NEL9gBCIX0tqw5M4oD-Tye_RLdjjA.8PwMCDhKCfTiNXus_XD2Up7b1FXB0HdwszVo3mdvoMI&dib_tag=se&keywords=litime&qid=1712325693&sprefix=litim,aps,169&sr=8-3&th=1&linkCode=sl1&tag=solar06e-20&linkId=591d563decb338729e6075a542764494&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Litime
                </Link>
              </li>
              <li>
                SOK 48V 5kWh server rack battery:{" "}
                <Link
                  to="https://www.currentconnected.com/product/eg4-lifepower4-lithium-battery-48v-100ah-server-rack-battery-ul1973-ul9540a/?ref=YtGM6OmQ"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Current Connected
                </Link>
              </li>
              <li>
                EG4 48V 5kWh server rack battery:{" "}
                <Link
                  to="https://signaturesolar.com/all-products/"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Current Connected
                </Link>
              </li>
            </ul>
            <p className="text-sm mt-2 text-gray-600">
              *Current Connected has better support than Signature Solar at the
              moment.
            </p>
          </div>

          {/* Hybrid Inverters Section */}

          <div>
            <h2 className="text-xl font-semibold mb-2">Hybrid Inverters</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                EG4 3kW hybrid off-grid inverter:{" "}
                <Link
                  to="https://signaturesolar.com/eg4-3kw-off-grid-inverter-3000ehv-48-3000w-output-5000w-pv-input-500-voc-input-pre-order/?ref=G4CIxdi2yArkmn"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Signature Solar
                </Link>
              </li>
              <li>
                EG4 6000XP:{" "}
                <Link
                  to="https://www.currentconnected.com/product/eg4-6000xp-inverter/?ref=YtGM6OmQ"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Current connected
                </Link>
              </li>
              <li>
                EG4 18k PV:{" "}
                <Link
                  to="https://www.currentconnected.com/product/eg4-18kpv-hybrid-inverter/?ref=YtGM6OmQ"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Current connected
                </Link>
              </li>
              <li>
                Growatt 5kW batteryless hybrid inverter:{" "}
                <a
                  href="https://signaturesolar.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Signature Solar
                </a>
              </li>
            </ul>
          </div>
          <br />

          <div>
            <h2 className="text-xl font-semibold mb-2">Solar panels</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                New and secondhand solar panels:{" "}
                <Link
                  to="https://www.santansolar.com/?ref=contact@cleversolarpower.com"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Santansolar
                </Link>
              </li>
              <li>
                100W solar panel:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-Monocrystalline-Solar-Compact-Design/dp/B07GF5JY35?crid=3DLJW404RC15&dib=eyJ2IjoiMSJ9.BD2YoHuZ_m4Vm6OlgMiAA4qj6aj7vDa4vr81reSuBaQWSUJEH_0wcuYMQJIWqDy2tM-z18-PlliOHBgy4gE6xvdfyLsEExMwJtVrHAHwm8oEDIn9Gdngee8c1U8XupwH5Zh6qkG6UYCKFFa1hAb_upPOXLqsN-clHXvc91nFedEXmVmdI0ImLP43X6muJIlt8dddMl1Xsg2ZtyFNICm2exwU_N5YNkHtrFUOwarxJnE.4XSgze9OCM4H5fhusiBvzMS48tZL24x21aPfCg1thmU&dib_tag=se&keywords=100w+solar+panel&qid=1711639395&sprefix=100w+solar+pane,aps,198&sr=8-3&linkCode=sl1&tag=solar06e-20&linkId=46cf8b1b955a46cfecafd267094bfc3b&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                MC-4 fuse:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-15-Waterproof-Line-Holder/dp/B00YG2BZM0?crid=BHWS654JRC1I&dib=eyJ2IjoiMSJ9.MlyB7ArHTue00Vc7Uf4w0la7RNIluAOWwvdkZYu5sbRXA2AcUo0enTpS7ZtFRZ98U4XGjYEu1l6G8Iv0PQqCDgzXy_LFNqllnNcOTtmfptK9bOiBw3ZNzk4oD3R6njFE2Lzij1zD-672z7Jg2jfE_-p7LhuSm742Xq6hD0WTv-dbowraUDEF2jZN2Y9j6jTFBEjX0k9clrZwDj0B50m1mc0dVWRQIDDMeVvLyImsukM.GP90zGNNC6mD1iW4OKuMMlR4odqUuv_8ZCfVH41jd6U&dib_tag=se&keywords=mc4%2Bfuse&qid=1711639441&sprefix=mc4%2Bfus,aps,165&sr=8-4&th=1&linkCode=sl1&tag=solar06e-20&linkId=04f0d9ee2abc7693f10a7c9de0c16a8a&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Y-branch connector:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-15-Waterproof-Line-Holder/dp/B00YG2BZM0?crid=BHWS654JRC1I&dib=eyJ2IjoiMSJ9.MlyB7ArHTue00Vc7Uf4w0la7RNIluAOWwvdkZYu5sbRXA2AcUo0enTpS7ZtFRZ98U4XGjYEu1l6G8Iv0PQqCDgzXy_LFNqllnNcOTtmfptK9bOiBw3ZNzk4oD3R6njFE2Lzij1zD-672z7Jg2jfE_-p7LhuSm742Xq6hD0WTv-dbowraUDEF2jZN2Y9j6jTFBEjX0k9clrZwDj0B50m1mc0dVWRQIDDMeVvLyImsukM.GP90zGNNC6mD1iW4OKuMMlR4odqUuv_8ZCfVH41jd6U&dib_tag=se&keywords=mc4%2Bfuse&qid=1711639441&sprefix=mc4%2Bfus,aps,165&sr=8-4&th=1&linkCode=sl1&tag=solar06e-20&linkId=04f0d9ee2abc7693f10a7c9de0c16a8a&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">DC Components</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Bluesea Fuse block:{" "}
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-Blade-Block/dp/B001P6FTHC?pd_rd_w=yB99Z&pf_rd_p=fd3ebcd0-c1a2-44cf-aba2-bbf4810b3732&pf_rd_r=7R9AHJQ2RQVRH1C76ZGD&pd_rd_r=34ee1d4b-6e8d-4aa8-8e22-845221a35cf7&pd_rd_wg=WukFm&pd_rd_i=B001P6FTHC&psc=1&linkCode=sl1&tag=solar06e-20&linkId=5fe19a9c5b842dad395a60450279e07c&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Battery isolator switch:{" "}
                <Link
                  to="https://www.amazon.com/dp/B000MMC914?_encoding=UTF8&ie=UTF8&sp_csd=d2lkZ2V0TmFtZT1zcF9yaGZfc2VhcmNoX3BlcnNvbmFsaXplZA%3D%3D&pd_rd_w=5u3al&content-id=amzn1.sym.ed82556b-5073-4521-a186-65fb40557bf5&pf_rd_p=ed82556b-5073-4521-a186-65fb40557bf5&pf_rd_r=CJZKJW54TQE0CQ7SS83D&pd_rd_wg=opVxy&pd_rd_r=b285fb89-fd09-44d7-94f2-b25fcd535180&th=1&linkCode=sl1&tag=solar06e-20&linkId=545e0b4619061c32bf32af168218bf30&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Solar disconnect with MC-4:{" "}
                <Link
                  to="https://www.amazon.com/DIHOOL-Disconnect-Outdoor-Breaker-Circuit/dp/B0B2LGDRNN?dib=eyJ2IjoiMSJ9.m_eddjVi8trzVHfhaIWCOVzItQSGiV5ciUKALMijO5KtclawSIWQjCuw_Q3112D3hZLOl-Swpr8KeACpa7tZGInqCMBggdzUudLnRv5MbfW8J54BEuNwdz39Pnam_lix1hUbfIZyQLD_XOO6j1oHKvo9IREQaSPYGAtWPlcF-O4A1qz5t4xoschuOZZdRVUzJ3tfMrygsnwKtM5Hmz4qRbgillvm8kV-yBLpLIMsoxGh_7m-9CVt4n-OKygxO8c4DuX_959tIwFraGPCX6Jg8VTkwdq1_P58M3HU6xDYgMA.B13Ij3sBee5iAcJ6CW7az0i7x60GSYZbIiEEvIA8NHw&dib_tag=se&keywords=solar%2Bdisconnect&qid=1711639248&sr=8-5&th=1&linkCode=sl1&tag=solar06e-20&linkId=6451b759fc2b85f203a32b941a4f5684&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <br />
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Cables and Wires</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Windynation welding cable 105°C:{" "}
                <Link
                  to="https://www.amazon.com/Welding-Battery-Copper-Flexible-Inverter/dp/B01MY9QVRI?crid=13XBB8WCHF08Z&keywords=windynation%2Bwire&qid=1707483872&s=industrial&sprefix=windynation%2Bwir,industrial,193&sr=1-4&th=1&linkCode=sl1&tag=solar06e-20&linkId=55812540e567d970937e79b35ba78612&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Speaker wire 75°C:{" "}
                <Link
                  to="https://www.amazon.com/Performance-Gauge-Speaker-Oxygen-Copper/dp/B01N4BIXDX?pd_rd_w=rzbNU&content-id=amzn1.sym.225b4624-972d-4629-9040-f1bf9923dd95:amzn1.symc.40e6a10e-cbc4-4fa5-81e3-4435ff64d03b&pf_rd_p=225b4624-972d-4629-9040-f1bf9923dd95&pf_rd_r=RMCSPDGPDJPFF9R6A9RG&pd_rd_wg=GHbRX&pd_rd_r=177c3a36-4afb-4eb9-88ec-ed854ba99699&pd_rd_i=B01N4BIXDX&th=1&linkCode=sl1&tag=solar06e-20&linkId=44f5e81a222dfc1f5b940635504f125e&language=en_US&ref_=as_li_ss_tl"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Fuses</h2>
            <ul className="list-disc pl-6 space-y-2">
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-MIDI-Fuse/dp/B004ZJ0QRO?crid=IFXWCGWIH10&keywords=midi%2Bfuses&qid=1703004082&sprefix=midi%2Bfuse,aps,249&sr=8-3&th=1&linkCode=sl1&tag=solar06e-20&linkId=0d04e8310b8535a41cc1fa94c4281bab&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MIDI fuse
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Littelfuse-Brand-04980900ZXT-Automotive-Holder/dp/B01M62MTQA?crid=1RDEVUEO3JN3J&keywords=midi+fuse+holder&qid=1703004125&sprefix=midi+fuses,aps,279&sr=8-2-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1&linkCode=sl1&tag=solar06e-20&linkId=e353733f1f2cf071b90229c59c188983&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  fuse holder
                </Link>
              </p>
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-300A-MEGA/dp/B000MMC7RU?crid=O3WGP5HZ80YO&keywords=mega+fuse&qid=1703004179&sprefix=mega+fuse,aps,181&sr=8-3&linkCode=sl1&tag=solar06e-20&linkId=c564fc1c31f221e7fd1f793a444acd9a&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MEGA fuse
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Victron-Energy-Fuse-Holder-MEGA-Fuse/dp/B01LZ6WUPS?crid=3LKORXLN3C3RS&keywords=mega+fuse+holder&qid=1703004224&sprefix=mega+fuse+holde,aps,192&sr=8-4&linkCode=sl1&tag=solar06e-20&linkId=286931e794377527ade6fb19eccf6ff4&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  fuse holder
                </Link>
              </p>
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-5190-Terminal/dp/B001AFZL9O?pd_rd_w=uopgZ&content-id=amzn1.sym.27be5bbe-3574-4f40-8c57-ce12023a2e77&pf_rd_p=27be5bbe-3574-4f40-8c57-ce12023a2e77&pf_rd_r=M4VM60M6JNCWNAA9HG1Y&pd_rd_wg=uAOCK&pd_rd_r=2c32256d-89d4-49c2-8ceb-835baca321b3&pd_rd_i=B001AFZL9O&th=1&linkCode=sl1&tag=solar06e-20&linkId=4a3c51b115fc5a5a8e92d880a8d9bbd2&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MRBF fuse
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-5191-Terminal/dp/B0019ZBTV4?crid=3I10FDW0SV7S3&keywords=mrfb%2Bfuse&qid=1703004303&sprefix=mrf,aps,252&sr=8-4&th=1&linkCode=sl1&tag=solar06e-20&linkId=3bfec385c286c2e94221614f5a609040&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fuse terminal
                </Link>
              </p>
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-5133-300A/dp/B000MMDLFM?crid=9DPHR8YA7RS1&keywords=anl+fuse&qid=1703004355&sprefix=anl+fuse,aps,181&sr=8-6&linkCode=sl1&tag=solar06e-20&linkId=05ce1fbdc762f1de834529d1fa3362eb&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ANL fuse
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-Block-Insulating/dp/B000K2K7TW?crid=XP59OJDLFTTA&keywords=anl+fuse+holder&qid=1703004399&sprefix=anl+fuse,aps,221&sr=8-2-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1&linkCode=sl1&tag=solar06e-20&linkId=a22a384cad6be75a57c4742e80d5175e&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  fuse holder
                </Link>
              </p>
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-5118-Class/dp/B000MMC7SY?crid=Q2GE36Q7HL1E&keywords=class%2Bt%2Bfuse&qid=1703004449&sprefix=class%2Bt%2Bfus,aps,199&sr=8-5&th=1&linkCode=sl1&tag=solar06e-20&linkId=6dcc007e0a7d660cd12da3d0017eefba&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Class-T fuse
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Blue-Sea-Systems-Class-Insulating/dp/B001VJ03LA?crid=2X4TNAA2K5RXE&keywords=class%2Bt%2Bfuse%2Bholder&qid=1703004481&sprefix=class%2Bt%2Bfuse%2Bholde,aps,182&sr=8-4&th=1&linkCode=sl1&tag=solar06e-20&linkId=afb3096e23d501c165693356db62683e&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  fuse holder
                </Link>
              </p>
              <p className="text-gray-700">
                <Link
                  to="https://www.amazon.com/3NA3836-SIEMENS-Fuse-160A-500V/dp/B07FBS9TF4?crid=3C3WLPYKOUOBF&keywords=nh00+fuse&qid=1703004521&sprefix=nh00+fus,aps,194&sr=8-2&linkCode=sl1&tag=solar06e-20&linkId=7fe04e86f65cfd255027a749691297af&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NH00
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.amazon.com/Heschen-Ceramic-Single-Pole-Holder-Fuse-Link/dp/B095P2YHVL?crid=DBZ9JNTQF78M&keywords=nh00+fuse+holder&qid=1703004561&sprefix=nh00+fuse+holde,aps,273&sr=8-7&linkCode=sl1&tag=solar06e-20&linkId=c62175fef00677265110a4d98119fa43&language=en_US&ref_=as_li_ss_tl"
                  className="text-blue-500 hover:underline text-orange-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  fuse holder
                </Link>
              </p>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Charge Controllers</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Victron Energy MPPT 100VDC 20Amp charge controller:{" "}
                <Link
                  to="https://www.amazon.com/Victron-SmartSolar-Charge-Controller-SCC110020160R/dp/B0877WVXLR?_encoding=UTF8&pd_rd_i=B0877WVXLR&pd_rd_r=d3dffe4a-df8f-44a2-8cea-268927192b3a&pd_rd_w=vA212&pd_rd_wg=l3FlA&pf_rd_p=fb1e266d-b690-4b4f-b71c-bd35e5395976&pf_rd_r=MFEQFANHBZA6ADADPG14&psc=1&refRID=MFEQFANHBZA6ADADPG14&linkCode=sl1&tag=solar06e-20&linkId=dcb52fd8bda8cfbd59c17176c26e9d71&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                EPever MPPT 20A charge controller:{" "}
                <Link
                  to="https://www.aliexpress.com/item/4000987488932.html?spm=a2g0o.productlist.0.0.427f20b4ANbn9C&algo_pvid=c605c811-14e8-4301-b6b8-88dfddcdf6da&algo_exp_id=c605c811-14e8-4301-b6b8-88dfddcdf6da-7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  aliexpress
                </Link>
              </li>
              <li>
                Renogy Rover 20A MPPT charge controller:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-Rover-Amp-12V-24V/dp/B07DNW1755?th=1&psc=1&linkCode=sl1&tag=solar06e-20&linkId=61cf624f1e328def0cb6146523e74f98&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
                or{" "}
                <Link
                  to="https://www.renogy.com/rover-li-20-amp-mppt-solar-charge-controller/"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Renogy
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Inverters</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Renogy 700/1000/2000/3000W 12V to 110V inverter:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-Solar-Inverter-Battery-Converter/dp/B07JMQ27WJ?th=1&linkCode=sl1&tag=solar06e-20&linkId=c6e919ba9a42cdbba76f320c4d407346&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Victron 250-1200VA 24V inverter:{" "}
                <Link
                  to="https://www.amazon.com/Victron-Energy-Phoenix-Inverter-VE-Direct/dp/B076TP3MCP?dchild=1&keywords=pure+sine+wave+inverter+24v&qid=1623817432&sr=8-22&linkCode=sl1&tag=solar06e-20&linkId=d94ed65fc78a38150fc77a74bac19317&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Hybrid Inverters</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                MPP Solar 1000W 12V hybrid solar inverter for 230VAC:{" "}
                <Link
                  to="https://www.ebay.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  eBay
                </Link>
              </li>
              <li>
                MPP Solar 1000W 12V hybrid solar inverter for 110VAC:{" "}
                <Link
                  to="https://www.ebay.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  eBay
                </Link>
              </li>
              <li>
                MPP Solar 3000w 24V hybrid solar inverter for 230VAC:{" "}
                <Link
                  to="https://www.ebay.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  eBay
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">
              Battery Indicator (Shunt)
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Cheap 100A shunt:{" "}
                <Link
                  to="https://www.aliexpress.com/item/4000726472671.html?spm=a2g0o.productlist.0.0.7cdd423bppiCAe&algo_pvid=073d3a17-aa06-4d4c-bde3-67617c542a21&algo_exp_id=073d3a17-aa06-4d4c-bde3-67617c542a21-0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Aliexpress
                </Link>
              </li>
              <li>
                Victron smart shunt 500 Amps:{" "}
                <Link
                  to="https://www.amazon.com/Victron-SmartShunt-500AMP-Bluetooth-Battery/dp/B0856PHNLX?keywords=victron+shunt+500a&qid=1675161380&sr=8-2&linkCode=sl1&tag=solar06e-20&linkId=777432660c0e63303001481b529908eb&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
              <li>
                Renogy 500A Shunt:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-500A-Battery-Monitor-Programmable/dp/B07RP5B5P7?dchild=1&keywords=battery+monitor&qid=1623819910&sr=8-3&linkCode=sl1&tag=solar06e-20&linkId=14a99381cc2d4fed03e2fc3f145117fc&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">
              Low Voltage Disconnect
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Victron smart battery protect 12/24V 100 Amps:{" "}
                <Link
                  to="https://www.amazon.com/dp/B07MXGZ7H8/ref=sspa_dk_detail_1?psc=1&pd_rd_i=B07MXGZ7H8&pd_rd_w=iwGRZ&pf_rd_p=80360d1c-2d74-4d2e-9034-f92fb5248b33&pd_rd_wg=8mZvS&pf_rd_r=28SEPKXVAR43WAMPF3WP&pd_rd_r=67dbc85d-1496-40bd-b61d-956cabaf659e&smid=A1LKUUGYID1OAO&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUE2MFYzMzVYUVhVVFkmZW5jcnlwdGVkSWQ9QTA4NzU3ODVLU0tFMzFHOUVOTjkmZW5jcnlwdGVkQWRJZD1BMDgwNTY0OTFUSkpWV0NTTktHOUcmd2lkZ2V0TmFtZT1zcF9kZXRhaWwmYWN0aW9uPWNsaWNrUmVkaXJlY3QmZG9Ob3RMb2dDbGljaz10cnVl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Batteries</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Trojan Lead-acid Batteries:{" "}
                <Link
                  to="https://www.trojanbatterysales.com/trojan-batteries-2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Trojan
                </Link>
              </li>
              <li>
                Renogy lead-acid AGM 12V 100Ah:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-Battery-Marine-Off-grid-Applications/dp/B075RFXHYK?dchild=1&keywords=agm+battery&qid=1623816476&sr=8-3&linkCode=sl1&tag=solar06e-20&linkId=6dec06b950d2897e4b6dfa0cd21d1120&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
                <p>or</p>
                <Link
                  className="text-blue-500 hover:underline text-orange-600"
                  to="https://www.renogy.com/deep-cycle-agm-battery-12-volt-100ah/"
                >
                  Renogy
                </Link>
              </li>
              <li>
                Lithium (LiFePo4) batteries:{" "}
                <Link
                  to="https://battlebornbatteries.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Battleborn
                </Link>
              </li>
              <li>
                Renogy lithium (LiFePo4) 12V 100Ah:{" "}
                <Link
                  to="https://www.amazon.com/Renogy-100Ah-Lithium-Phosphate-Battery/dp/B07YXL2TC7?th=1&psc=1&linkCode=sl1&tag=solar06e-20&linkId=b7a86bb75b97aeeb57a055fdaf5a958d&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
                or{" "}
                <Link
                  className="text-blue-500 hover:underline text-orange-600"
                  to="https://www.renogy.com/12v-100ah-pro-smart-lithium-iron-phosphate-battery-w-bluetooth-self-heating-function/"
                >
                  Renogy
                </Link>
              </li>
              <li>
                DIY Lithium battery cells LiitoKala 120Ah 3.2V:{" "}
                <Link
                  to="https://www.aliexpress.com/item/1005002591796298.html?spm=a2g0o.detail.1000023.9.2452565aVHYiJH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Aliexpress
                </Link>
              </li>
              <li>
                DIY Lithium battery BMS Daly:{" "}
                <Link
                  to="https://www.aliexpress.com/item/1005001803913333.html?spm=a2g0o.productlist.0.0.1f5ab65cAhbFFq&algo_pvid=5368c9f3-4f29-431e-be13-e1055054edd5&algo_exp_id=5368c9f3-4f29-431e-be13-e1055054edd5-0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Aliexpress
                </Link>
              </li>
            </ul>
          </div>
          <br />
          <div>
            <h2 className="text-xl font-semibold mb-2">Others</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Marine grade heatshrink:{" "}
                <Link
                  to="https://www.amazon.com/Wirefy-190-Heat-Shrink-Tubing/dp/B09NW7954L?th=1&linkCode=sl1&tag=solar06e-20&linkId=e7ae80e79084428ffa4404776273a4ad&language=en_US&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline text-orange-600"
                >
                  Amazon
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* About Me Card */}
        <div className="bg-white shadow-md rounded-md p-6">
          <h2 className="text-xl text-center font-bold mb-4">About Me</h2>
          <img
            src="https://via.placeholder.com/150"
            alt="Author"
            className="w-40 h-40 mx-auto rounded-full mb-4"
          />
          <p className="text-center text-sm text-gray-700">
            Welcome to Cleversolarpower.com! I'm the driving force behind this
            site, which attracts over 1,000 daily visitors interested in solar
            energy. I'm also the author of a popular solar energy book, with
            over 80,000 copies sold and more than 2,000 reviews averaging 4.5
            stars. My mission is to demystify solar power and make it accessible
            to everyone. Join me in exploring the potential of solar power to
            create a cleaner, brighter future! Link to the book on Amazon. Read
            more about me here, check out my Youtube channel, or send me a
            message.
          </p>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default DiySolarParts;
